import { render, staticRenderFns } from "./latest_polls.vue?vue&type=template&id=4076eb97&"
import script from "./latest_polls.vue?vue&type=script&lang=js&"
export * from "./latest_polls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports